import React, { useMemo } from 'react';
import {
  Box,
  ChevronLeftIcon,
  ChevronRightIcon,
  Preloader,
  RawButton,
  SimpleHint,
  Text,
  useResponsive,
} from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

import { TBD_TITLE } from '@/common/constants';

// import { PLData } from './SliderPL';
import { getSplittedMoneyAmount } from './utils';
interface WrapperProps {
  isProfit: boolean;
}

const WHITE_BACKGROUND = 'rgba(255, 255, 255, 0.10)';

const Wrapper = styled(Box)<WrapperProps>`
  ${({ isProfit, theme }) => {
    if (isProfit) {
      return css`
        background-color: ${theme.colors.profitContainer};
      `;
    }
    return css`
      background-color: ${theme.colors.lossContainer};
    `;
  }}
`;
const ValueText = styled(Text)`
  font-family: 'Oswald', serif;
`;

const DecimalText = styled(Text)`
  font-family: 'Oswald', serif;
`;

const ButtonWrapper = styled(Box)`
  width: 96px;
  opacity: 0.25;
  &:hover {
    opacity: 1;
    background-color: ${WHITE_BACKGROUND};
  }
`;
interface Props {
  label?: string;
  subLabel?: string;
  hint?: string;
  value?: number;
  additionalHint?: string;
  percents?: number;
  isLoading?: boolean;
  onNext?: () => void;
  onPrevious?: () => void;
  isSmallMode?: boolean;
}
const SliderPLItem: React.FC<Props> = ({
  label,
  subLabel,
  hint,
  additionalHint,
  value,
  onNext,
  onPrevious,
  isLoading,
  isSmallMode,
}) => {
  const { isMobile } = useResponsive();
  const isProfit = useMemo(() => (value || 0) >= 0, [value]);
  const { value: mainAmount, decimal } = useMemo(() => getSplittedMoneyAmount(value || 0), [value]);
  // const currentPercents = useMemo<string>(() => {
  //   if (percents) {
  //     if (percents > 0) {
  //       return `+${percents}%`;
  //     }
  //     return `${percents}%`;
  //   }
  //   return '+0%';
  // }, [percents]);
  //
  const width = isMobile ? undefined : isSmallMode ? '130px' : '200px';
  if (isLoading) {
    return (
      <Wrapper
        data-testid="slider-pl_loading"
        direction="column"
        fill={isSmallMode}
        round="moduleRound"
        align="center"
        isProfit={isProfit}
        justify="center"
        width={{ min: width }}
        style={isMobile ? { flex: 1 } : {}}
        height={isMobile ? '112px' : isSmallMode ? '' : '200px'}
      >
        <Preloader testId="pnl_loading" size={50} />
      </Wrapper>
    );
  }
  return (
    <Wrapper
      direction="column"
      fill={isSmallMode}
      round={isSmallMode ? 'container1Round' : 'moduleRound'}
      isProfit={isProfit}
      data-testid="slider-pl"
      pad={isSmallMode ? 'spacing12' : ''}
      justify={isSmallMode ? 'center' : 'end'}
      width={{ min: width }}
      style={isMobile ? { flex: 1 } : {}}
      height={isMobile ? '112px' : isSmallMode ? '' : '200px'}
    >
      <Box direction="column" align="center" justify="center">
        <SimpleHint
          preferAlign={SimpleHint.HintPlacement.TOP}
          width={isMobile ? '85%' : '340px'}
          content={
            <Box direction="column">
              <Text data-testid="slider-pl_hint" size="small" textAlign="center" weight={500}>
                {hint}
              </Text>
              {additionalHint && (
                <Text
                  color="textOnColor"
                  size="small"
                  textAlign="center"
                  weight={500}
                  margin={{ top: 'spacing8' }}
                >
                  {additionalHint}
                </Text>
              )}
            </Box>
          }
        >
          <Box width={{ max: isSmallMode ? '106px' : '176px' }}>
            <Text
              color="textOnColor"
              textAlign="center"
              data-testid="slider-pl_label"
              style={{ textDecoration: 'underline dotted', opacity: 0.5, cursor: 'pointer' }}
            >
              {label}
            </Text>
            <Text
              color="textOnColor"
              textAlign="center"
              data-testid="slider-pl_sub-label"
              style={{ textDecoration: 'underline dotted', opacity: 0.5, cursor: 'pointer' }}
            >
              {subLabel}
            </Text>
          </Box>
        </SimpleHint>
        {/* <Hint
          hintWidth={isMobile ? '90%' : 340}
          hintHeight={400}
          hintElement={
          
          }
        >
          
        </Hint> */}

        {(value || 0) === 0 ? (
          <>
            <ValueText
              margin={{ top: 'spacing4' }}
              data-testid="slider-pl_tbd"
              size="2xl"
              color="investmentsProfit"
              weight={700}
            >
              {TBD_TITLE}
            </ValueText>
            <Box height="20px" />
          </>
        ) : (
          <>
            <ValueText
              margin={{ top: 'spacing4' }}
              data-testid="slider-pl_value"
              size="2xl"
              color={isProfit ? 'investmentsProfit' : 'investmentsLoss'}
              weight={700}
            >
              {mainAmount}

              <DecimalText size="medium" data-testid="slider-pl_decimal" weight={400}>
                {decimal}
              </DecimalText>
            </ValueText>
            <Box height="20px"></Box>
            {/* {percents ? (
              <PercentsText
                size="medium"
                weight={400}
                data-testid="slider-pl_percents"
                color={isProfit ? 'investmentsProfit' : 'investmentsLoss'}
              >
                {currentPercents}
              </PercentsText>
            ) : (
              <Box height="20px"></Box>
            )} */}
          </>
        )}
      </Box>
      {!isSmallMode && !isMobile && (
        <Box margin={{ top: '20px', bottom: 'xxxs' }} direction="row" justify="between">
          <RawButton data-testid="slider-pl_left-chevron_button" onClick={onPrevious}>
            <ButtonWrapper
              round="110px"
              width={{ min: '96px' }}
              height="40px"
              align="center"
              justify="center"
            >
              <ChevronLeftIcon color="iconOnColor" />
            </ButtonWrapper>
          </RawButton>
          <RawButton data-testid="slider-pl_right-chevron_button" onClick={onNext}>
            <ButtonWrapper
              round="110px"
              width={{ min: '96px' }}
              height="40px"
              align="center"
              justify="center"
            >
              <ChevronRightIcon color="iconOnColor" />
            </ButtonWrapper>
          </RawButton>
        </Box>
      )}
    </Wrapper>
  );
};

export default SliderPLItem;
